<header class="header-container d-flex align-items-center justify-content-between p-3 border-bottom">

    <!-- Logo -->
    <a (click)="navigateToDashboard()" class="logo">
        <img src="assets/images/logo.svg" alt="" class="img-fluid" />
    </a>

    <!-- Mobile Toggle -->
    <div class="mobile-toggle d-lg-none" (click)="toggleMenu()">
        <span class="material-icons">menu</span>
    </div>

    <!-- Right Section -->
    <div class="header-right" [class.open]="isMenuOpen">

        <!-- Call -->
        <div class="call-section d-flex align-items-center gap-2">
            <span class="material-icons-outlined text-primary">call</span>
            <span class="fw-light">{{ 'CALL_US_NOW' | translate }} 845-682-3067</span>
        </div>

        <!-- Language -->
        <div class="language-toggle d-flex align-items-center gap-2">
            Spanish
            <label class="switch">
                <input type="checkbox" (change)="toggleLanguage($event)" [checked]="selectedLanguage === 'eng'">
                <span class="slider round"></span>
            </label> English
        </div>

        <!-- Buttons -->
        <div class="header-buttons d-flex align-items-center gap-2 flex-wrap">

            <button mat-flat-button color="primary" *ngIf="router.url !== '/how-it-works'" [routerLink]="['/how-it-works']">{{ 'REFER_A_FRIEND' | translate }}</button>

            <button mat-flat-button color="primary" *ngIf="router.url !== '/agent-demo'" [routerLink]="['/agent-demo']">{{ 'AGENT_DEMO' | translate }}</button>

            <button mat-flat-button color="primary" *ngIf="isLoggedIn" (click)="HelpPage()">{{ 'HELP' | translate }}</button>

            <ng-container *ngIf="!isLoggedIn">
                <button mat-flat-button color="primary" [routerLink]="['/signup/firm-agent']">{{ 'SIGN_UP' | translate }}</button>
                <button mat-flat-button color="primary" [routerLink]="['/login']">{{ 'LOG_IN' | translate }}</button>
            </ng-container>

            <button mat-flat-button color="primary" *ngIf="isRootUrl && isLoggedIn" (click)="navigateToDashboard()">{{ 'DASHBOARD' | translate }}</button>
        </div>

        <!-- Icons -->
        <div class="header-icon d-flex align-items-center gap-3" *ngIf="isLoggedIn">

            <div class="notification-wrapper" (click)="showNotification()">
                <span class="material-symbols-outlined">notifications</span>
                <span class="notification-count" *ngIf="notificationCount > 0">
                    {{notificationCount}}
                </span>
            </div>

            <div ngbDropdown>
                <span class="material-symbols-outlined" ngbDropdownToggle>manage_accounts</span>
                <div ngbDropdownMenu>
                    <button ngbDropdownItem [routerLink]="['/changePassword']">Change Password</button>
                    <button ngbDropdownItem [routerLink]="['/change-email']">Change Email</button>
                    <button ngbDropdownItem (click)="logout()">Sign Out</button>
                </div>
            </div>

        </div>

    </div>
</header>
<router-outlet></router-outlet>
<div class="main-footer">
    <ul>
        <li><a href="/customer-about">{{'ABOUT_US_FOOTER' | translate }}</a></li>
        <li><a href="/contact-us">{{'CONTACT_US' | translate }}</a></li>
        <li (click)="openDialog('T&C')"><a>{{'TERMS_AND_CONDITIONS' | translate }}</a></li>
        <li (click)="openDialog('PrivacyPolicy')"><a>{{'PRIVACY_POLICY' | translate }}</a></li>
        <li><a [routerLink]="['/faq-page']">{{'FAQS_FOOTER' | translate }}</a></li>
        <li><a [routerLink]="['/partner']">{{'PARTNERS_FOOTER' | translate }}</a></li>
    </ul>
</div>

<div class="notification-container" *ngIf="showNotifications" #notificationPanel>
    <app-notification #notification (notificationLength)="getNotificationLength($event)">
    </app-notification>
</div>